import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const includes = ['Planificación lista para usar desde el primer día', 'Clases con objetivo, desarrollo y cierre', 'Cueings listos para decir palabra por palabra', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio', 'Checklist pre y durante la clase', 'Planillas de seguimiento de alumnas', 'Adaptaciones para grupos heterogéneos', '100% adaptado al Pilates formativo argentino'];
export const TomoIncludes = () => {
  return <section className="py-6 md:py-10 bg-white border-y border-sage-100" data-id="element-402">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-403">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-sage-50 rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-sm border border-sage-200" data-id="element-404">
          <h3 className="text-xl md:text-3xl font-bold text-charcoal font-playfair mb-5 md:mb-8 text-center" data-id="element-405">
            Cada tomo incluye:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2.5 md:gap-y-4" data-id="element-406">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-2 md:gap-3" data-id="element-407">
                <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-408" />
                <span className="text-sm text-gray-700 font-medium" data-id="element-409">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};